import { Component } from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-rules-game',
  imports: [TranslatePipe],
  templateUrl: './rules-game.html',
  styleUrl: './rules-game.scss'
})
export class RulesGame {

  pdfLink(){
    return environment.pdfFile;
  }

}
